'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (key) {
    if (typeof window === 'undefined') {
        console.warn('Session storage middleware only runs in browsers. Defaulting to non-persistent storage.');
        return [];
    }

    if (typeof sessionStorage === 'undefined') {
        console.warn('Session storage does not appear to be supported by this browser. Defaulting to non-persistent storage.');
        return [];
    }

    var initialState = getStorage(key) || [];
    return initializeNonPersistentStorage(key, initialState);
};

var setStorage = function setStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
};

var getStorage = function getStorage(key) {
    var storage = sessionStorage.getItem(key);
    if (storage) {
        return JSON.parse(storage);
    }
    return [];
};

var addStorageItem = function addStorageItem(key, value) {
    var storage = getStorage(key);
    storage.push(value);
    setStorage(key, storage);
};

var spliceStorageItem = function spliceStorageItem(key, start, count) {
    var storage = getStorage(key);
    var items = storage.splice(start, count);
    setStorage(key, storage);
    return items;
};

var initializeNonPersistentStorage = function initializeNonPersistentStorage(key) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var storage = initialState;
    storage.key = key;
    storage.oldPush = storage.push;

    storage.push = function (item) {
        addStorageItem(this.key, item);
        return Array.prototype.push.apply(this, [item]);
    };

    storage.splice = function (start, count) {
        spliceStorageItem(this.key, start, count);
        return Array.prototype.splice.apply(this, [start, count]);
    };

    return storage;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/sessionStorage.js
// module id = 757
// module chunks = 0